module.exports = __webpack_public_path__ + "img/icon-home2.e7775790.svg";